import { ExtraOptions, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        loadChildren: () => import('./components/components.routes').then(m => m.COMPONENTS_ROUTES)
    },
    {
        path: '**',
        pathMatch: 'full',
        component: PageNotFoundComponent
    },
];
